'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LocationField = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = require('react-intl');

var _object = require('helpers/object');

var _Location = require('./Items/Location');

var _SearchBoxField = require('./SearchBoxField');

var _SearchBox = require('./SearchBox.helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var itemToString = function itemToString(i) {
  return (i && i.locationName || '').replace(/<[^>]*>/g, '');
};

var LocationField = exports.LocationField = function LocationField(props) {
  return _react2.default.createElement(
    _SearchBoxField.SearchBoxField,
    (0, _extends3.default)({}, (0, _object.pick)((0, _keys2.default)(_SearchBoxField.SearchBoxField.propTypes), props), {
      mobilePlaceholderText: 'Neighborhood or zip',
      desktopPlaceholderText: 'neighborhood, address',
      itemToString: itemToString,
      isClearable: false,
      prompt: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'search.searchbox.near',
        defaultMessage: 'Near'
      })
    }),
    function (_ref) {
      var getItemProps = _ref.getItemProps,
          highlightedIndex = _ref.highlightedIndex,
          inputValue = _ref.inputValue;

      var items = inputValue ? props.suggestions : props.history;

      return items.length > 0 && _react2.default.createElement(
        'div',
        { className: 'dropdown searchbox__panel' },
        _react2.default.createElement(
          'ul',
          { className: 'dropdown__content' },
          items.map(_SearchBox.normalizeItem).map(function (item, index) {
            return _react2.default.createElement(_Location.Location, (0, _extends3.default)({}, getItemProps({
              item: item,
              key: item.place_id,
              searchId: item.location_id,
              highlighted: index === highlightedIndex,
              onRemoveClick: props.onRemoveItem
            }), {
              item: item
            }));
          })
        )
      );
    }
  );
};

LocationField.propTypes = (0, _extends3.default)({
  onRemoveItem: _propTypes2.default.func.isRequired,
  history: _propTypes2.default.array,
  suggestions: _propTypes2.default.array
}, (0, _object.omit)(['prompt', 'mobilePlaceholderText', 'itemToString', 'children'], _SearchBoxField.SearchBoxField.propTypes));